import React from 'react';
import { Card, Descriptions, Skeleton, Typography } from '../../../components';
import { Webmin } from './Webmin';
import { returnAgentUrl, showHeartbeatStatus, showLastHeartbeat } from '../utils';
import { RMSAgents } from './RMSAgents';
import { convertToFlatNetworkProperties } from '../../../lib/helpers';
import { appliancePropertiesConfig } from '../appliancePropertiesConfig';
import { ApplianceTags } from './ApplianceTags';
import { CloudProperties } from './CloudProperties';

const { Text } = Typography;

export const ApplianceReadiness = React.memo(
    ({ appliance, cloudAccountId, cloudAccountName, logsUrl, cloudAccountType, error }) => {
        let applianceProperties = appliancePropertiesConfig[cloudAccountType].getApplianceProperties(appliance);

        return (
            <>
                <Card title="Appliance Readiness" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Status:">
                            <Text>{showHeartbeatStatus(appliance)}</Text>
                        </Descriptions.Item>
                        ,
                        {error && (
                            <Descriptions.Item label="Error:">
                                <Text>
                                    "This Cloud Account information is not available at the moment. Please check if this
                                    Cloud Account still exists."
                                </Text>
                            </Descriptions.Item>
                        )}
                        <Descriptions.Item label="Last Heartbeat">
                            <Text>{showLastHeartbeat(appliance)}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Cloud Account ID">
                            <Text copyable>{cloudAccountId}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Cloud Account Name">
                            <Text copyable>{cloudAccountName}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Appliance ID">
                            <Text copyable>{appliance.id}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Appliance IP Address:">
                            <Text copyable>{appliance.ip_address}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Appliance Version Number">
                            <Text>{appliance.appliance_version_num || 'Version not available'}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Appliance Version At Creation">
                            <Text>{appliance.appliance_original_version_num || 'Version not available'}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
                <Webmin appliance={appliance} logsUrl={logsUrl} cloudAccountType={cloudAccountType} />
                {returnAgentUrl(appliance, cloudAccountType) && (
                    <RMSAgents appliance={appliance} cloudAccountType={cloudAccountType} />
                )}
                {appliance.public_ip_address && (
                    <Card title="IP Address" size="small">
                        <Descriptions column={1} size="small">
                            <Descriptions.Item label="Appliance Public IP address">
                                <Text copyable>{appliance.public_ip_address}</Text>
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                )}
                <Card title="Appliance Creation" size="small">
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="Appliance Created At">
                            <Text>{new Date(appliance.created_at).toLocaleString(undefined, { hour12: false })}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
                {Object.keys(applianceProperties.tags).length > 0 && (
                    <ApplianceTags applianceProperties={applianceProperties} />
                )}
                <CloudProperties applianceProperties={applianceProperties} />
            </>
        );
    },
);
